import React from 'react';
import PublicLayout from '@layouts/PublicLayout';
import { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import ResetPassword from '../ResetPassword';
import VerifyEmail from '../VerifyEmail';

const ACTION_MODES = {
  RESET_PASSWORD: 'resetPassword',
  VERIFY_EMAIL: 'verifyEmail',
} as const;

type ActionMode = (typeof ACTION_MODES)[keyof typeof ACTION_MODES];

const ACTION_COMPONENTS: Record<
  string,
  { component: React.ComponentType; title: string }
> = {
  [ACTION_MODES.RESET_PASSWORD]: {
    component: ResetPassword,
    title: 'Restablecer contraseña',
  },
  [ACTION_MODES.VERIFY_EMAIL]: {
    component: VerifyEmail,
    title: 'Verificar correo electrónico',
  },
};

interface ActionComponentProps {
  mode: string;
}

function ActionComponent({ mode }: ActionComponentProps) {
  const Component = ACTION_COMPONENTS[mode]?.component;
  return Component ? <Component /> : null;
}

export default function AuthActionHandler() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const mode = searchParams.get('mode');

  useEffect(() => {
    if (!mode || !Object.values(ACTION_MODES).includes(mode as ActionMode)) {
      navigate('/', { replace: true });
    }
  }, [mode, navigate]);

  if (!mode || !ACTION_COMPONENTS[mode]) {
    return null;
  }

  return (
    <PublicLayout title={ACTION_COMPONENTS[mode].title}>
      <ActionComponent mode={mode} />
    </PublicLayout>
  );
}
